import { isValidLocale } from "./config";

/**
 * `path` in the language of the page the shopper is on.
 *
 * A store serves its DEFAULT language without a prefix and its others with
 * one, so the prefix is copied from the current URL rather than derived from a
 * locale: a bare URL stays bare (adding the default's own prefix earns a 301),
 * and `/ar/cart` leads to `/ar/checkout` instead of switching the shopper to
 * the default language on a redirect they did not ask for.
 *
 * @param path - A path without a locale prefix, starting with `/`.
 * @param currentPathname - The browser pathname, as `usePathname()` returns it.
 */
export function pathInCurrentLocale(path: string, currentPathname: string | null): string {
  const prefix = currentPathname?.split("/").filter(Boolean)[0];
  if (!prefix || !isValidLocale(prefix)) return path;
  return path === "/" ? `/${prefix}` : `/${prefix}${path}`;
}
